import React, { ReactElement } from 'react';
import Home from 'pages/Home/Home';
import Campaigns from 'pages/Campaigns/Campaigns';
import Brands from 'pages/Brands/Brands';
import Stores from 'pages/Stores/Stores';
import Tenants from 'pages/Tenants/Tenants';
import Store from 'pages/Stores/Store/Store';
import Campaign from 'pages/Campaigns/Campaign/Campaign';
import Login from 'pages/Auth/Login/Login';
import Callback from 'pages/Auth/Callback/Callback';
import UserGroups from 'pages/UserGroups/UserGroups';
import UserGroup from 'pages/UserGroups/UserGroup/UserGroup';
import Users from 'pages/Users/Users';
import Logout from 'pages/Auth/Logout/Logout';
import Tags from 'pages/Tags/Tags';
import Activities from 'pages/Activities/Activities';
import CreateActivityWizard from 'pages/Activities/ActivityWizard/CreateActivityWizard';
import UpdateActivityWizard from 'pages/Activities/ActivityWizard/UpdateActivityWizard';
import Activity from 'pages/Activities/Activity/Activity';
import Reports from 'pages/Reports/Reports';
import { CaslPermission } from 'config/ability';
import MediaGalleryPage from 'pages/MediaGalleryPage/MediaGalleryPage';
import ActivityAssignment from 'pages/Activities/ActivityAssignment/ActivityAssignment';

export enum SidenavGroupEnum {
  Main = 'main',
  CustomSettings = 'customSettings',
}

export interface RouteInterface {
  path: string;
  element: ReactElement;
  title?: ReactElement | string;
  icon?: ReactElement;
  showBreadcrumbs?: boolean;
  showOnHeader?: boolean;
  showOnSidenav?: boolean;
  sidenavGroup?: SidenavGroupEnum;
  permission?: CaslPermission;
}

export const privateRoutes: RouteInterface[] = [
  {
    path: '/',
    element: <Home />,
    title: 'Dashboard',
    // icon: <DashboardIcon />,
  },
  {
    path: '/tenants',
    element: <Tenants />,
    title: 'Tenants',
    // icon: <PersonIcon />,
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    permission: {
      action: 'access',
      subject: 'SuperTenant',
    },
  },
  {
    path: '/activities',
    element: <Activities />,
    title: 'Activities',
    // icon: <EventAvailableIcon />,
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.Main,
    permission: {
      action: 'read',
      subject: 'Activity',
    },
  },
  {
    path: '/activities/:activityId',
    element: <Activity />,
    title: 'Activity Overview',
    // icon: <EventAvailableIcon />,
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'Activity',
    },
  },
  {
    path: '/activities/:activityId/assignments/:assignmentId',
    element: <ActivityAssignment />,
    title: 'Activity Overview',
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'Activity',
    },
  },
  {
    path: '/stores',
    element: <Stores />,
    title: 'Stores',
    // icon: <StoreIcon />,
    showOnSidenav: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'Store',
    },
  },
  {
    path: '/stores/:storeId',
    element: <Store />,
    title: 'Store Overview',
    // icon: <StoreIcon />,
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'Store',
    },
  },
  {
    path: '/activities/create',
    element: <CreateActivityWizard />,
    title: 'Create Activity',
    permission: {
      action: 'create',
      subject: 'Activity',
    },
  },
  {
    path: '/activities/edit/:activityId',
    element: <UpdateActivityWizard />,
    title: 'Edit Activity',
    permission: {
      action: 'update',
      subject: 'Activity',
    },
  },
  {
    path: '/campaigns',
    element: <Campaigns />,
    title: 'Campaigns',
    // icon: <PeopleIcon />,
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.Main,
    permission: {
      action: 'read',
      subject: 'Campaign',
    },
  },
  {
    path: '/campaigns/:campaignId',
    element: <Campaign />,
    title: 'Campaign Overview',
    // icon: <PeopleIcon />,
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'Campaign',
    },
  },
  {
    path: '/brands',
    element: <Brands />,
    title: 'Brands',
    // icon: <RedeemIcon />,
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    permission: {
      action: 'read',
      subject: 'Brand',
    },
  },
  {
    path: '/users',
    element: <Users />,
    // icon: <PeopleIcon />,
    title: 'Users',
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    permission: {
      action: 'read',
      subject: 'User',
    },
  },
  {
    path: '/groups',
    element: <UserGroups />,
    title: 'Permissions',
    // icon: <GroupsIcon />,
    showBreadcrumbs: true,
    showOnSidenav: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    permission: {
      action: 'read',
      subject: 'UserGroup',
    },
  },
  {
    path: '/groups/:groupId',
    element: <UserGroup />,
    title: 'Permissions',
    showBreadcrumbs: true,
    permission: {
      action: 'read',
      subject: 'UserGroup',
    },
  },
  {
    path: '/tags',
    element: <Tags />,
    title: 'Tags',
    // icon: <LocalOfferIcon />,
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.CustomSettings,
    permission: {
      action: 'read',
      subject: 'Tag',
    },
  },
  {
    path: '/reports',
    element: <Reports />,
    title: 'Reports',
    showOnSidenav: true,
    showBreadcrumbs: true,
    sidenavGroup: SidenavGroupEnum.Main,
    permission: {
      action: 'read',
      subject: 'Activity',
    },
  },
  {
    path: '/reports/create',
    element: <CreateActivityWizard />, // This needs to be updated to a new Create Report Wizard
    title: 'Create Report',
    permission: {
      action: 'read',
      subject: 'Activity',
    },
  },
  {
    path: '/gallery',
    element: <MediaGalleryPage />,
    title: 'Gallery',
    showOnSidenav: true,
    sidenavGroup: SidenavGroupEnum.Main,
  },
];

export const publicRoutes: RouteInterface[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/auth/callback',
    element: <Callback />,
  },
  {
    path: '/logout',
    element: <Logout />,
  },
];

export const allRoutes = [...privateRoutes, ...publicRoutes];

export const sidenavLinks = allRoutes.filter((route) => route.showOnSidenav);
